import cn from 'classnames'
import { useCallback } from 'react'
import { Tab } from './components/Tab'

import styles from './Tabs.module.scss'

interface TabsProps<TValue> {
  values: {
    value: TValue
    label: string
  }[]
  value?: string
  onChange: (value: TValue) => void
  className?: string
}
export const Tabs = <TValue,>({
  values = [],
  onChange = () => {},
  value = '',
  className,
}: TabsProps<TValue>) => {
  const selectTab = useCallback(
    (value: TValue) => {
      onChange(value)
    },
    [onChange]
  )

  return (
    <div className={cn(styles.container, className)}>
      {values.map((item) => (
        <Tab
          key={String(item.value)}
          selected={item.value === value}
          name={item.label}
          value={item.value}
          onSelect={selectTab}
        />
      ))}
    </div>
  )
}
